// extracted by mini-css-extract-plugin
module.exports = {"event":"OrderItems_event__2cZMh","header":"OrderItems_header__2x7Ax","subtitle":"OrderItems_subtitle__1tRqM","logoSize16":"OrderItems_logoSize16__2xhbj"};